import type { AgentDto } from "@agent/data/dto/agent.dto";
import { AgentMapper } from "@agent/data/mappers/agent.mapper";
import type { AgentFiltersQuery } from "@agent/domain/models/agent-filters-query.model";
import type { Agent, AgentFilter } from "@agent/domain/models/agent.model";
import { webCoreTypes } from "@core/core-types.di";
import { FallbackError } from "@core/domain/errors/fallback.error";
import type { IotApiClient } from "@iot-platform/core";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class AgentDatasource {
    static readonly AGENT_PATH = "/agent_risks";

    constructor(
        @inject(webCoreTypes.infrastructure.IotApiClient)
        private readonly iotApiClient: IotApiClient,
        @inject(AgentMapper)
        private readonly agentMapper: AgentMapper,
    ) {}

    fetchAll(agentFilter?: AgentFilter): ResultAsync<Agent[], FallbackError> {
        const query: AgentFiltersQuery = {
            name: agentFilter?.name,
            category: agentFilter?.category,
            pathogen_type: agentFilter?.pathogenType?.length
                ? agentFilter.pathogenType.map(String)
                : undefined,
            crop_type_id: agentFilter?.cropTypeId?.length
                ? agentFilter.cropTypeId.map(String)
                : undefined,
        };

        return this.iotApiClient.http
            .get<AgentDto[]>(AgentDatasource.AGENT_PATH, { query })
            .mapErr(() => new FallbackError())
            .map((response) => this.agentMapper.mapList(response.data));
    }
}
